import React, { useState, useEffect } from 'react';
import './App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import NavigationHeader from './components/layout/NavigationHeader';
import HomeHero from './components/pages/HomeHero';
import VideoSection from './components/ui/VideoSection';
import FeaturedEventsSection from './components/features/FeaturedEventsSection';
import CuratedEventsSection from './components/features/CuratedEventsSection';
import DiscoverArtistsSection from './components/features/DiscoverArtistsSection';
import CommunitySection from './components/features/CommunitySection';
import FavoritesSection from './components/features/FavoritesSection';
import AccountPage from './components/pages/AccountPage';
import SiteFooter from './components/layout/SiteFooter';
import AuthModal from './components/auth/AuthModal';

// Main content component that handles conditional rendering based on login status
const MainContent = ({ currentPage, onNavigate }) => {
  const { user } = useAuth();

  const renderPage = () => {
    switch (currentPage) {
      case 'account':
        return <AccountPage onNavigate={onNavigate} />;
      default:
        return (
          <>
            <HomeHero />
            <VideoSection />
            <FeaturedEventsSection />
            {user ? (
              // Show personalized content for logged-in users
              <>
                <CuratedEventsSection />
                <DiscoverArtistsSection />
                <CommunitySection />
                <FavoritesSection />
              </>
            ) : (
              // Show general content for logged-out users
              <>
                <CuratedEventsSection isLoggedOut={true} />
                <DiscoverArtistsSection />
                <CommunitySection />
                <FavoritesSection isLoggedOut={true} />
              </>
            )}
            <SiteFooter />
          </>
        );
    }
  };

  return renderPage();
};

function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');

  const handleNavigation = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <AuthProvider>
      <div className={`App ${isLoaded ? 'loaded' : ''}`}>
        <NavigationHeader onNavigate={handleNavigation} currentPage={currentPage} />
        <MainContent currentPage={currentPage} onNavigate={handleNavigation} />
        <AuthModal />
      </div>
    </AuthProvider>
  );
}

export default App; 